export default __webpack_public_path__ + "static/moment_2-dcad06f9e2958f4a6a6e84103a37e349.jpg";